import React from 'react';
import { FeedbackTitleUnderlineSvg } from './styles';

const FeedbackTitleUnderline: React.FC = () => (
  <FeedbackTitleUnderlineSvg
    viewBox="0 0 193 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    preserveAspectRatio="none"
  >
    <path
      d="M191.277 4.14153C191.048 4.14153 190.819 4.14153 177.064 4.06105C163.308 3.98057 136.034 3.81962 117.858 3.5355C99.6815 3.25139 91.4304 2.849 71.8236 2.40027C52.2168 1.95154 21.5042 1.46867 8.66221 1.50159C-4.17981 1.53452 1.77934 2.09787 14.4755 2.95142C27.1717 3.80498 46.4243 4.93168 63.1037 6.23641C79.783 7.54113 93.3057 8.98974 100.73 9.81647C110.704 11.131 118.059 12.4235 123.202 13.3661C123.9 13.4892 124.588 13.5697 126.685 13.8965"
      stroke="#EB6424"
      strokeWidth="2.5"
      strokeLinecap="round"
      pathLength={1}
    />
  </FeedbackTitleUnderlineSvg>
);

export default FeedbackTitleUnderline;
